export default "__VITE_ASSET__Ca6HApIu__"